import ThankYou from '../ThankYou';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, ICustomerState, AppointmentActionCreator, IAppointmentState, CustomerActionCreator, VehiclesActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator, MenusActionCreator, NewVehicleActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState & ICustomerState & IAppointmentState) => ({
    custInfo: state.Customer.Customer,
    appointment: state.Appointment,
    vehicle: state.Appointment.ApptVeh,
    viewMode: state.Framework.viewMode,
    specData: state.Specs.specs,
    theme: state.Framework.theme,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
});

const mapDispatchToProps = {
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearMenusState: MenusActionCreator.ClearMenusState,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    updateOps: AppointmentActionCreator.UpdateApptOps,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ThankYou);